import { useState } from "react";
import { TextComponent } from "./TextComponent";
import { Column } from "./Column";

interface SwitchProps {
	label: string;
	value?: boolean;
	initialChecked: boolean;
	onChange: (newValue: boolean) => void;
}

export const Switch = ({ label, value, initialChecked, onChange }: SwitchProps) => {
	const [isChecked, setIsChecked] = useState<boolean>(initialChecked);
	const isControlled = value !== undefined;
	const handleToggle = () => {
		if (!isControlled) {
			const newValue = !isChecked;
			setIsChecked(newValue);
			onChange(newValue);
		} else {
			onChange(!value);
		}
	};

	return (
		<Column className="gap-2">
			<TextComponent variant="h6">{label}</TextComponent>
			<label className="relative w-fit items-center cursor-pointer">
				<input
					type="checkbox"
					className="sr-only peer"
					checked={isControlled ? value! : isChecked}
					onChange={handleToggle}
				/>
				<div className="group peer bg-white rounded-full duration-300 w-16 h-8 ring-2 ring-primary/60 after:duration-300 after:bg-primary/60 peer-checked:after:bg-primary peer-checked:ring-primary after:rounded-full after:absolute after:h-6 after:w-6 after:top-1 after:left-1 after:flex after:justify-center after:items-center peer-checked:after:translate-x-8" />
			</label>
		</Column>
	);
};
